import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { User, profileType } from '../models/user.model';
import { ProfileDetailListPage } from '../pages/profile-detail-list/profile-detail-list.page';
import { Device } from '@capacitor/device';
import { PlatformchkService } from '../services/platformchk.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public UUID;

  constructor(
    private modalController: ModalController,
    private platformchk: PlatformchkService,
  ) {
    this.getUUID();
  }

  async getUUID() {
    if(this.platformchk.isApp) {
      const device = await Device.getId();
      this.UUID = device.identifier;
    }else {
      this.UUID = 'computer';
    }
  }
  /**
   *
   * 상대방 프로필 상세!!
   *
   * @param userId 상대방 uid
   * @param type
   * defaultProfiles: 프로필!
   * bgProfiles: 배경화면!
   */
  public async goDetailUserProfile(userId: string, type: string): Promise<void> {
    const modal = await this.modalController.create({
      component: ProfileDetailListPage,
      cssClass: 'my-custom-class',
      componentProps: {
        userId,
        type,
      },
    });

    await modal.present();
  }

  /**
   *
   * 사용자의 대표 이미지 추출!
   * @param user user 전체!
   * @param type
   * defaultProfiles: 프로필!
   * bgProfiles: 배경화면!
   * @returns
   */
  public getProfile(user: User, type: string): string {
    if (!user) {
      return '';
    }

    const profiles: Array<profileType> = user[type];

    // 프로필 없을 경우
    if (!profiles || profiles.length == 0) {
      // 프로필 기본화면
      if (type == 'defaultProfiles') {
        return 'assets/imgs/user-basic.png';
      }

      // 배경 기본화면
      return 'assets/imgs/edit-basic.png';
    }

    // 첫번째 프로필이 비디오일 경우 썸네일 리턴!
    if (profiles[0].type == 'video') {
      return profiles[0].thumbnail;
    }

    // 프로필이 있는데 비디오가 아닐 경우는 image 일 경우!
    if (profiles[0].thumbnail) {
      return profiles[0].thumbnail;
    }else {
      return profiles[0].content;
    }
  }
}
